import { jobAwayCarriedCargo } from './jobAwayCarriedCargo-sidecar'
import { jobBuild } from './jobBuild-sidecar'
import { jobConstructHull } from './jobConstructHull-sidecar'
import { jobDebuild } from './jobDebuild-sidecar'
import { jobDeconstructHull } from './jobDeconstructHull-sidecar'
import { jobDrink } from './jobDrink-sidecar'
import { jobEat } from './jobEat-sidecar'
import { jobFillWater } from './jobFillWater-sidecar'
import { jobHarvest } from './jobHarvest-sidecar'
import { jobIdle } from './jobIdle-sidecar'
import { jobMeltIce } from './jobMeltIce-sidecar'
import { jobMine } from './jobMine-sidecar'
import { jobSleep } from './jobSleep-sidecar'
import { jobStack } from './jobStack-sidecar'
import { jobTakeOffSuit } from './jobTakeOffSuit-sidecar'
import { jobFillBattery } from './jobFillBattery-sidecar'
import { jobFillWith } from './jobFillWith-sidecar'
import { jobMoveTo } from './jobMoveTo-sidecar'
import { taskPutAway } from './taskPutAway-sidecar'
import { jobUnstack } from './jobUnstack-sidecar'
import { taskUnstackCargo } from './taskUnstackCargo-sidecar'
import { taskStackCargo } from './taskStackCargo-sidecar'
import { taskDrink } from './taskDrink-sidecar'
import { taskFill } from './taskFill-sidecar'

export function registerAll() {
  jobAwayCarriedCargo.register()
  jobBuild.register()
  jobConstructHull.register()
  jobDebuild.register()
  jobDeconstructHull.register()
  jobDrink.register()
  jobEat.register()
  jobFillWater.register()
  jobHarvest.register()
  jobIdle.register()
  jobMeltIce.register()
  jobMine.register()
  jobSleep.register()
  jobStack.register()
  jobUnstack.register()
  jobTakeOffSuit.register()
  jobFillBattery.register()
  jobFillWith.register()
  jobMoveTo.register()

  taskPutAway.register()
  taskStackCargo.register()
  taskUnstackCargo.register()
  taskDrink.register()
  taskFill.register()
}
